import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { clientPortalUsersActivityReportPayloadSchema } from './schema'

export const clientPortalUsersActivityReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'client',
    component: lazyRouteComponent(() => import('./ReportPage')),
    validateSearch: (search: Record<string, unknown>) => clientPortalUsersActivityReportPayloadSchema.parse(search)
  })
